'use es6';

import { INITIALIZE_CONFIG } from 'pricing-pages-unified-ui/constants/ActionTypes';
export const storeEnvironmentConfig = config => dispatch => {
  dispatch({
    type: INITIALIZE_CONFIG,
    config
  });
};